import axios from "axios";
import { parsePhoneNumberFromString } from "libphonenumber-js";

export const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
}

export const normalizePhoneNumber = (value) => {
    if (!value) return "";

    const raw = String(value).trim().replace(/[-()\s]/g, "");
    let phone = raw.startsWith("00") ? "+" + raw.slice(2) : raw;
    if (!phone.startsWith("+")) {
        phone = "+" + phone;
    }

    try {
        const parsed = parsePhoneNumberFromString(phone);
        if (parsed && parsed.isValid()) {
            return parsed.number; // always returns in E.164 format with + prefix
        }
    } catch (e) {
        return "";
    }

    return "";
}

function isValidPhoneNumber(phone) {
    const parsed = parsePhoneNumberFromString(phone);
    return parsed && parsed.isValid();
}

// export const detectUserCountry = async () => {
//     try {
//         const response = await axios.get('http://ip-api.com/json/');
//         return response.data.countryCode.toLowerCase();
//     } catch (error) {
//         console.error('Error detecting country:', error);
//         try {
//             const fallbackResponse = await axios.get('https://ipwho.is/');
//             return fallbackResponse.data.country_code.toLowerCase();
//         } catch (fallbackError) {
//             console.error('Fallback API also failed:', fallbackError);
//             return 'us';
//         }
//     }
// };

export const detectUserCountry = async () => {
    const services = [
        {
            url: "https://ipapi.co/json/",
            parser: (data) => data.country_code
        },
        {
            url: "https://ipwho.is/",
            parser: (data) => data.country_code
        },
        {
            url: "https://ipinfo.io/json",
            parser: (data) => data.country
        },
        {
            url: "https://api.country.is/",
            parser: (data) => data.country
        }
    ];

    for (const service of services) {
        try {
            const response = await axios.get(service.url, {
                timeout: 4000
            });

            const code = service.parser(response.data);

            if (code) {
                return code.toLowerCase();
            }

        } catch (err) {
            console.warn(`Country API failed: ${service.url}`);
        }
    }

    console.error("All country detection APIs failed.");
    return "us"; // fallback
};
